import React from 'react'
import moment from 'moment'
import IconField from './icon-field'
import IconRow from './icon-row'
import EnrollCutoff from './enroll-cutoff'
import DropCutoff from './drop-cutoff'

const Cutoff = ({ experience = {} }) => {
    if (experience.enrollCutoff >= 0 && experience.dropCutoff >= 0) {
        const enrollCutoff = moment(experience.date).subtract(experience.enrollCutoff, 'days')
        const dropCutoff = moment(experience.date).subtract(experience.dropCutoff, 'days')
        if (enrollCutoff.isSame(dropCutoff, 'day')) {
            return (
                <IconRow>
                    <IconField  sm={12}>
                        <EnrollCutoff experience={experience} single={true} />
                    </IconField>
                </IconRow>
            )
        }
    }
    return (
        <React.Fragment>
            <IconRow>
                <IconField  sm={12}>
                    <EnrollCutoff experience={experience} />
                </IconField>
            </IconRow>
            <IconRow>
                <IconField  sm={12}>
                    <DropCutoff experience={experience} />
                </IconField>
            </IconRow>
        </React.Fragment>
    )
}

export default Cutoff